<template>
  <div>
    <v-container>
      <v-card class="page-404">
        <div class="page-404__container">
          <v-row class="align-center">
            <v-col cols="12" md="5" lg="5" class="text-center text-md-left my-6">
              <h2 class="mb-8">Not Authorized</h2>

              <div class="page-404__subtitle">You are not authorized <br />to view this page.</div>

              <v-btn class="mt-8" rounded depressed color="secondary" dark @click="$router.go(-1)">Go Back</v-btn>
            </v-col>
          </v-row>
        </div>
      </v-card>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'NoAccess',
  components: {},
}
</script>

<style lang="scss">
.page-404 {
  &__container {
    min-height: calc(100vh - 250px);
    max-width: 1100px;
    margin: 0 auto;
    padding: 50px 120px;
    display: flex;
    align-items: center;
  }

  &__image {
    /*margin-right: 80px;*/
    margin-right: 80px;
    max-width: 700px;
    text-align: center;
  }

  &__subtitle {
    font-weight: 300;
    font-size: 18px;
    line-height: 140%;
    color: #868686;
  }
}

///////////////////////RESPONSIVE//////////////////////////
@media screen and (max-width: 1200px) {
}

@media screen and (max-width: 960px) {
  .page-404 {
    &__image {
      margin-right: 0;

      img {
        max-height: 150px;
      }
    }
  }
}

@media screen and (max-width: 600px) {
  .page-404 {
    &__container {
      padding-right: 16px;
      padding-left: 16px;
    }
  }
}
</style>
